import React from "react";

export default function CTISRulesPage() {
  return (
    <>
      <h1 className="h3 mb-3">CTIS Rules</h1>
      <p className="text-muted">Placeholder page for CTIS rules management.</p>
    </>
  );
}